module.exports = __webpack_public_path__ + "img/onboarding_icon_1.0c4b0766.svg";